import { Container } from '@ui/wrapper'
import Accordion from '@ui/accordion'
import { StyledText, SectionWrapper } from './style'

const BSWPreisFuerWirtschaftsJournalismusArea = ({
  data,
  dataMessage,
  ...rest
}) => {
  return (
    <SectionWrapper {...rest}>
      {dataMessage?.texts?.length > 0 && (
        <Container style={{ marginBottom: '50px' }}>
          {dataMessage.section_title?.title && (
            <StyledText
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <h3>{dataMessage.section_title.title}</h3>
            </StyledText>
          )}
          {dataMessage.section_title?.subtitle && (
            <StyledText
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '30px'
              }}
            >
              <h4>{dataMessage.section_title.subtitle}</h4>
            </StyledText>
          )}
          {dataMessage.texts?.map((text, i) => (
            <StyledText
              dangerouslySetInnerHTML={{
                __html: text.content
              }}
              key={i}
            />
          ))}
        </Container>
      )}
      <Container>
        {data?.section_title?.title && (
          <StyledText
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '20px'
            }}
          >
            <h4>{data.section_title.title}</h4>
          </StyledText>
        )}
        {data?.items?.length > 0 && (
          <StyledText>
            <Accordion data={data.items} />
          </StyledText>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default BSWPreisFuerWirtschaftsJournalismusArea
